import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Health = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.835 14.298c0-.503.41-.91.916-.91h4.498c.506 0 .916.407.916.91v4.561h4.595c.506 0 .917.408.917.91v4.465c0 .502-.41.91-.917.91h-4.595v4.561c0 .503-.41.91-.916.91H19.75a.913.913 0 0 1-.916-.91v-4.561H14.24a.913.913 0 0 1-.917-.91v-4.465c0-.502.41-.91.917-.91h4.595v-4.561Zm1.833.91v4.561c0 .503-.41.91-.917.91h-4.595v2.645h4.595c.507 0 .917.407.917.91v4.561h2.664v-4.561c0-.503.41-.91.917-.91h4.595v-2.645h-4.595a.913.913 0 0 1-.917-.91v-4.561h-2.664Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45 6.423c4.61-4.563 12.07-4.565 16.668 0L22 8.293l1.882-1.868v-.001c4.61-4.563 12.07-4.565 16.67 0a11.636 11.636 0 0 1 0 16.537L22.647 40.733a.921.921 0 0 1-1.296 0L3.448 22.973c-4.597-4.577-4.598-11.983 0-16.548l.002-.001ZM4.745 7.71c-3.882 3.854-3.883 10.108 0 13.975L22 38.804l17.255-17.13a9.825 9.825 0 0 0 0-13.963c-3.882-3.854-10.182-3.856-14.077 0h-.001l-2.529 2.51a.92.92 0 0 1-1.296 0l-2.53-2.51C14.94 3.857 8.64 3.855 4.745 7.71Z"
  }));
});
Health.displayName = 'Health';
Health.defaultProps = {
  'aria-label': 'Health'
};
export default Health;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Health.js
// module id = 3645
// module chunks = 11